module.exports = __webpack_public_path__ + "img/thomas_rieger.8b7da0f8.jpg";